function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "nonzero",
  d: "M16.023 21.077v.023l-.011-.012L16 21.1v-.023l-9-8.95L9.115 10l6.897 6.858L22.908 10l2.115 2.127-9 8.95z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/arrow_svgo.2be66c52.svg";
export { SvgComponent as ReactComponent };